<script setup>
defineProps({
  cardContent: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div class="article-cards-item">
    <PostContent :content="cardContent" />
  </div>
</template>

<style lang="postcss">
.article-cards-item {
  padding: 32px 32px 40px;
  background-color: rgba(255, 246, 251, 96%);
  border-radius: 16px;

  & > .post-content figure.content-image {
    margin: 0 auto;
  }

  & .content-image--isBigImage,
  & .content-image--isVerticalImage {
    max-width: var(--content-max-width);
    width: 100%;
    padding: 0;
    margin: 0;
  }

  & .content-carousel__slide {
    width: 718px;
  }

  & .content-image--isFullScreen .content-image__img {
    border-radius: 16px;
  }

  & .content-image--isFullScreen .content-image__text,
  & .content-image--isBigImage .content-image__text {
    max-width: var(--content-max-width);
    padding: 0;
    margin: 0;
  }

  & .content-image--isColumnWidth {
    max-width: var(--content-max-width);
    padding: 0;
  }
  @media (--tablet-vp) {
    & .content-carousel__slide {
      width: calc(100% - 50px);
    }

    & > .post-content .content-image {
      margin: 0 auto;
      max-width: fit-content;
    }

    .content-image__text {
      max-width: 100%;
      margin: 0;
      padding: 0;
    }
  }

  @media (--small-vp) {
    padding: 16px 12px 24px;
  }
}
</style>
